import deepmerge from 'deepmerge';
import { readonlyTheme as baseReadonlyTheme } from '@truvity/widget__forms-mui-theme';
import { LinkedVcClaimDef, NumericStringClaimDef, TextareaClaimDef } from '@truvity/widget__vcs-builder';

import { ReadonlyLinkedCredential } from './renderers/LinkedCredential';
import { ReadonlyTextareaField } from './renderers/TextareaField';
import { ReadonlyNumericStringField } from './renderers/NumericStringField';

export const readonlyTheme = deepmerge(baseReadonlyTheme, {
    typeRenderers: {
        [LinkedVcClaimDef.rendererName]: ReadonlyLinkedCredential,
        [TextareaClaimDef.rendererName]: ReadonlyTextareaField,
        [NumericStringClaimDef.rendererName]: ReadonlyNumericStringField,
    },
});
